<div #dd class="dropdown" tabindex="0" (click)="dd.classList.toggle('active'); $event.stopPropagation();">
  <ng-content></ng-content>
  <div class="dropdown-content">
    <a *ngFor="let option of options" (click)="handleOptionClick($event, option)">{{option.labelFr}}</a>
  </div>
</div>


// WEBPACK FOOTER //
// ./src/app/element/submenu/submenu.component.html